<template>
  <v-data-table-server
    :page="props.page"
    :sort-by="props.sortBy"
    model-value="props.selected"
    :items-per-page-options="props.itemsPerPageOptions"
    :show-current-page="props.showCurrentPage"
    :items-per-page-text="props.itemsPerPageText"
    :items-per-page-all-text="props.itemsPerPageAllText"
    :loading="props.loading"
    :headers="props.headers"
    :items="props.items"
    :item-value="props.itemValue"
    :fixed-header="props.fixedHeader"
    :items-per-page="itemsPerPage"
    :item-selectable="props.itemSelectable"
    :return-object="props.returnObject"
    :mobile-breakpoint="mobileBreakpoint"
    :custom-key-sort="customSort"
    :must-sort="props.mustSort"
    :show-select="props.showSelect"
    @update:page="updatePage"
    @update:sort-by="updateSortBy"
    @update:model-value="updateSelected"
  >
    <!-- Forward all received slots -->
    <template v-for="(slotFn, name) in $slots" :key="name" #[name]="slotProps">
      <data-table-cell
        v-if="isSingleColumnSlot(name)"
        :class="cellClass(slotProps.column.key, slotProps.column.class)"
      >
        <slot :name="name" v-bind="slotProps" />
      </data-table-cell>
      <slot v-else :name="name" v-bind="slotProps" />
    </template>
  </v-data-table-server>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { DataTableServerProp } from "@plugins/common/types";
import DeviceUtils from "@utils/device.utils";
import { generateCustomSortObject } from "@plugins/vuetify/datatable-helper";

//INTENTIONAL NOT IMPLEMENTING "update:options" use "update:page" or "update:sortBy"
const emit = defineEmits(["update:modelValue", "update:page", "update:sortBy"]);

const props = defineProps<DataTableServerProp>();

const updatePage = (page: number) => {
  emit("update:page", page);
};
const updateSortBy = (sortBy) => {
  emit("update:sortBy", sortBy);
};

const updateSelected = (modelValue) => {
  emit("update:modelValue", modelValue);
};

const isSingleColumnSlot = (slotName) => {
  return slotName.startsWith("item.");
};

const cellClass = computed(() => (key: string, clazz) => {
  return {
    [clazz]: true,
    active: sortColumn.value === key,
  };
});

const itemsPerPage = computed(() =>
  props.itemsPerPage ? props.itemsPerPage : DeviceUtils.isMobile() ? 10 : 20,
);

const sortColumn = computed(() => {
  return props.sortBy.length > 0 ? props.sortBy[0].key : "";
});

const customSort = computed(() => generateCustomSortObject(props.headers));
const mobileBreakpoint = computed(() => (props.mobileBreakpoint ? props.mobileBreakpoint : 0));
</script>
